import type { AlpineComponent } from 'alpinejs'
import Cookies from 'js-cookie'

export function Modal(
  modalRef: string,
  cookieName: string | undefined | null,
  enableTimer: boolean = false,
  delay: number = 0,
): AlpineComponent<{
  ref: undefined | HTMLDialogElement
  isOpen: boolean
  init(): void
  openModal(): void
  closeModal(): void
  handleClose(): void
  stopMedia(): void
  setCookie(): void
}> {
  return {
    ref: undefined,
    isOpen: false,

    init() {
      this.ref = this.$refs[modalRef] as HTMLDialogElement

      // Esc closes the dialog without going through closeModal, so listen for
      // the dialog's own close event as well.
      this.ref?.addEventListener('close', () => this.handleClose())

      if (!cookieName) return

      const cookie = Cookies.get(cookieName)

      if (enableTimer && cookie != '1') {
        setTimeout(() => {
          this.openModal()
        }, delay * 1000)
      }
    },

    openModal() {
      this.ref?.showModal()
      this.isOpen = true
    },

    closeModal() {
      this.ref?.close()
      this.handleClose()
    },

    handleClose() {
      // Reached from both closeModal and the close event, so only run once.
      if (!this.isOpen) return

      this.isOpen = false
      this.stopMedia()
      this.setCookie()
    },

    stopMedia() {
      // Closing a dialog just hides it, so an embedded video keeps playing.
      // Swapping the iframe for a fresh copy of itself unloads the player and
      // leaves it ready for the next open.
      this.ref
        ?.querySelectorAll<HTMLIFrameElement>('.embed-container iframe')
        .forEach((iframe) => iframe.replaceWith(iframe.cloneNode()))
    },

    setCookie() {
      if (cookieName) {
        Cookies.set(cookieName, '1', { expires: 90 })
      }
    },
  }
}
